import classNames from "classnames";

import arrowDown from "/assets/sort-arrow-down.svg";
import styles from "./styles.module.css";

export default function SortableColumnHead({
  onClick,
  status, // asc, desc, null
  children,
}) {
  const handleClick = (e) => {
    e.preventDefault();

    if (typeof onClick === "function")
      onClick(nextStatus());
  };

  const nextStatus = () => {
    if (status === "asc")
      return "desc";

    return "asc";
  };

  return (
    <th>
      <a href="#" onClick={handleClick} className={styles["sort-link"]}>
        <>
          {children}
          {status && (
            <img src={arrowDown} className={classNames(styles["sort-icon"], { [styles["sort-icon--desc"]]: status === 'desc' })} />
          )}
        </>
      </a>
    </th>
  );
}
